import { TState } from '@r1-frontend/entities/stores/auth/reducer';

export const selectCsrf = (state: TState) => {
    return state.auth.csrf || '';
};
